import type { CSSProperties } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { useCurrentTheme, withLangAndTheme } from '@/utils/siteSync';

interface LogoProps {
  className?: string;
}

export function Logo({ className = '' }: LogoProps) {
  const { language } = useLanguage();
  const theme = useCurrentTheme();
  const isDark = theme === 'dark';

  const imgStyle: CSSProperties = {
    maxHeight: 'clamp(34px, 5.8vw, 48px)',
    maxWidth: 'clamp(175px, 17vw, 240px)',
    width: 'auto',
    height: 'auto',
    display: 'block',
  };

  return (
    <a href={withLangAndTheme('https://haikoinnovations.com', language, theme)} className={`flex items-center ${className}`} aria-label="Haiko Innovations">
      <span style={{ position: 'relative', display: 'inline-block', lineHeight: 0 }}>
        {/* Dark theme logo */}
        <img
          src="/logo-header-dark.png"
          alt="Haiko Innovations"
          style={{
            ...imgStyle,
            opacity: isDark ? 1 : 0,
          }}
          aria-hidden={!isDark}
        />
        {/* Light theme logo overlaid */}
        <img
          src="/logo-header-light.png"
          alt=""
          style={{
            ...imgStyle,
            position: 'absolute',
            top: 0,
            left: 0,
            opacity: isDark ? 0 : 1,
          }}
          aria-hidden={isDark}
        />
      </span>
    </a>
  );
}
